import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortAddress'
})
export class ShortAddressPipe implements PipeTransform {
  transform(item: string, _attr: string): string {
    return item.replace(/^[0-9]*[ ]/, "");
  }
}
